import React from "react";
import { FC } from "react";
import { makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core";
import { useQuery } from "react-query";
import { FormRenderProps } from "react-final-form";
import Typography from "@material-ui/core/Typography";
import Button from "../../../../../components/Button";
import Autocomplete from "../../../../../components/Autocomplete";
import Field from "../../../../../components/Field";
import Loading from "../../../../../components/Loading";
import useSchoolQueries from "../../../../school/hooks/useSchoolQueries";

const useStyles = makeStyles((theme: Theme) => ({
  field: {
    marginBottom: theme.spacing(2),
  },
}));

const SchoolProfileForm: FC<FormRenderProps> = ({
  handleSubmit,
  submitting,
}) => {
  const classes = useStyles();

  const { fetchAll } = useSchoolQueries();
  const { isLoading, isFetching, data } = useQuery<any>("schools", fetchAll);

  if (isLoading || isFetching) {
    return <Loading />;
  }

  return (
    <>
      <form onSubmit={handleSubmit}>
        <Field
          fullWidth
          className={classes.field}
          name="school"
          placeholder="School"
          label={
            <Typography variant={"h4"} color={"primary"}>
              Select School
            </Typography>
          }
          options={data.data}
          clear={"true"}
          component={Autocomplete}
        />
        <Button
          type="submit"
          color="secondary"
          variant="contained"
          disabled={submitting}
        >
          Save
        </Button>
      </form>
    </>
  );
};

export default React.memo(SchoolProfileForm);
